import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function determinePageType(pathname) {
  if (!pathname || pathname === '/') {
    return 'home';
  }
  const [first] = pathname.split('/').filter(Boolean);
  return first || 'home';
}

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search || ''}`;
    const payload = {
      pagePath,
      pageTitle: typeof document !== 'undefined' ? document.title : '',
      pageType: determinePageType(location.pathname),
      referrer: typeof document !== 'undefined' ? document.referrer : '',
      screenWidth: typeof window !== 'undefined' ? window.innerWidth : null,
      screenHeight: typeof window !== 'undefined' ? window.innerHeight : null,
    };
    const body = JSON.stringify(payload);

    const sendEvent = () => {
      if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' });
        navigator.sendBeacon('/api/analytics/events', blob);
        return;
      }
      fetch('/api/analytics/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {
        // Swallow errors so we never block navigation when analytics fail.
      });
    };

    sendEvent();
  }, [location.pathname, location.search]);

  return null;
}

export default AnalyticsTracker;
